import List from 'src/storage/list';

class PopupSelectModel extends List {
  id = 'PopupSelectModel';
  defaultState = () => ({
    caches: {},
    current: 'recent',
    params: {}
  });

  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {};

  listParams(loadMore) {
    const req = {
      skip: 0,
      limit: this.listLimit,
      ...this.state.params
    };
    const query = this.listInput('search');

    if (query.length > 0) {
      req.query = query;
    }
    if (this.state.canProcess && !this.state.canProcess(req)) {
      return null;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

const model = new PopupSelectModel();
export default model;
